export default function ComparisonSection() {
  const comparisons = [
    {
      feature: "Spreadsheet",
      hoobuy: true,
      pandabuy: true,
      sugargoo: false,
      allchinabuy: true,
    },
    {
      feature: "Interface",
      hoobuy: "⭐⭐⭐⭐⭐",
      pandabuy: "⭐⭐⭐⭐",
      sugargoo: "⭐⭐⭐",
      allchinabuy: "⭐⭐⭐⭐",
    },
    {
      feature: "Frete",
      hoobuy: "⭐⭐⭐⭐",
      pandabuy: "⭐⭐⭐",
      sugargoo: "⭐⭐⭐⭐",
      allchinabuy: "⭐⭐⭐",
    },
    {
      feature: "Suporte PT-BR",
      hoobuy: "✅",
      pandabuy: "❌",
      sugargoo: "❌",
      allchinabuy: "❌",
    },
    {
      feature: "Links Verificados",
      hoobuy: "✅",
      pandabuy: "✅",
      sugargoo: "❌",
      allchinabuy: "✅",
    },
    {
      feature: "Atualizações",
      hoobuy: "⭐⭐⭐⭐⭐",
      pandabuy: "⭐⭐⭐",
      sugargoo: "⭐⭐",
      allchinabuy: "⭐⭐⭐",
    },
    {
      feature: "Preço",
      hoobuy: "⭐⭐⭐⭐",
      pandabuy: "⭐⭐⭐⭐",
      sugargoo: "⭐⭐⭐⭐⭐",
      allchinabuy: "⭐⭐⭐⭐",
    },
  ];

  return (
    <section id="comparacao" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Comparações
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Veja como a Hoobuy Spreadsheet se compara com outras plataformas do mercado.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="overflow-x-auto rounded-xl border border-background-200/60">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-foreground-950">
                <th className="text-left p-4 text-white font-semibold rounded-tl-xl">Recurso</th>
                <th className="p-4 text-white font-semibold">
                  <span className="text-primary-400">Hoobuy</span>
                </th>
                <th className="p-4 text-white/70 font-medium">Pandabuy</th>
                <th className="p-4 text-white/70 font-medium">Sugargoo</th>
                <th className="p-4 text-white/70 font-medium rounded-tr-xl">AllChinaBuy</th>
              </tr>
            </thead>
            <tbody>
              {comparisons.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-b border-background-200/40 last:border-b-0 ${
                    idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                  }`}
                >
                  <td className="p-4 text-foreground-800 font-medium">{row.feature}</td>
                  <td className="p-4 text-center text-primary-600 font-semibold">
                    {typeof row.hoobuy === "boolean" ? (row.hoobuy ? "✅" : "❌") : row.hoobuy}
                  </td>
                  <td className="p-4 text-center text-foreground-600">
                    {typeof row.pandabuy === "boolean" ? (row.pandabuy ? "✅" : "❌") : row.pandabuy}
                  </td>
                  <td className="p-4 text-center text-foreground-600">
                    {typeof row.sugargoo === "boolean" ? (row.sugargoo ? "✅" : "❌") : row.sugargoo}
                  </td>
                  <td className="p-4 text-center text-foreground-600">
                    {typeof row.allchinabuy === "boolean" ? (row.allchinabuy ? "✅" : "❌") : row.allchinabuy}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}